import React from 'react';
import NavMenu from './navMenu/NavMenu';

const Layout = (props) => {
    return (
        <div>
            <NavMenu />
            <div className="contentWebPage">{props.children}</div>
        </div>
    );
};

export default Layout
